<template>
<div class="wrapper">
<h1>Privacy Policy</h1>

<p>This Privacy Policy governs the manner in which IVM Credit, provided by IVM INDIA FINANCE PRIVATE LIMITED,collects, uses, maintains, and discloses information collected from users (each, a "User") of the https://www.ivmindiafinance.in website ("Site") and IVM Credit mobile application ("App"). This privacypolicy applies to the Site, App, and all products and services offered by IVM Credit.</p>
<h2>Data Collection:</h2>
<p>We gather personal data including your personal and work information to check your creditworthiness, includes
    name, email, phone number, date of birth, government-issued ID (e.g., Aadhaar or PAN), financial and
    employment information when you submit a loan application via the App. This data aids in processing your
    loan requests, validating your identity, evaluating your creditworthiness, and furnishing the requested
    services.</p>
<p>When you use the App, we may collect the following types of information:</p>
<p>Collecting your information aims to verify identity, assess risk, and facilitate efficient loan processing
    while complying with regulations.</p>
<h2>Information Collection</h2>
<p>- Contact Information: We collect your mobile number, name, Aadhaar number, PAN card details, email ID, date
    of birth, for account creation, KYC verification, and customer service purposes.</p>
<p>- Financial Information: We collect your financial situation, includes income and expenditure, work status,
    etc.</p>
<p>- Usage Data: Information such as application crash reports and page views within the app is collected for
    customer contact and service improvement.</p>
<p>- Location Information: To provide anti-fraud services, we collect location data.</p>
<p>- Album Access: We may request access to your photo gallery to facilitate the uploading of identification
    documents for verification purposes.</p>
<p>- Device Information: We collect information about your device, including hardware models, IP address,
    operating systems and versions, software, preferred languages, unique device identifiers, advertising
    identifiers, serial numbers, device motion data, and mobile network information, to enhance risk awareness
    and customer service.</p>
<h2>Use of Collected Information</h2>
<p> IVM Credit collects and uses Users' personal information for the following purposes:</p>
<p>- Account Creation: To create and manage the User's account on the Site or App.</p>
<p>- KYC Verification: To perform Know Your Customer (KYC) verification and other related customer services.</p>
<p>- Loan Facilitation: To process and facilitate the disbursement of loans by our Lending Partners registered
    with the Reserve Bank of India.</p>
<p>- Service Improvement: To improve customer service by responding to your customer service requests and
    support needs more efficiently.</p>
<p>- Fraud Prevention: To use location and device information for the purpose of preventing fraudulent
    activities.</p>
<h2>Data Protection:</h2>
<p>Safeguarding your personal data is our top priority, and we implement a robust array of technical,
    administrative, and physical safeguards to shield it from unauthorized access, disclosure, alteration, or
    destruction. Our security protocols undergo regular reviews and updates to effectively combat evolving
    threats.</p>
<h2>Information Sharing:</h2>
<p>We might partner with third-party service providers, like credit bureaus, financial institutions, and payment
    processors, to streamline loan processing and associated services. Be assured, we do not trade, sell, or
    lease your personal data to third parties for marketing reasons.</p>
<p>1.Service Providers: We may enlist third-party service providers to help us manage the App, handle loan
    applications, perform credit checks, analyze data, and offer other services on our behalf.</p>
<p>2.Legal Obligations: We may reveal your personal information if compelled by law, legal proceedings, or if we
    deem it necessary to comply with relevant laws, regulations, or governmental requests.</p>
<p>3.Consent: Your personal information may be shared with third parties if you've given us your explicit
    consent to do so.</p>
<h2>Modifications to Privacy Policy:</h2>
<p>We retain the prerogative to amend or revise our Privacy Policy at any juncture. In the event of such
    alterations, we will promptly notify you by posting the updated Privacy Policy on this platform. Continued
    utilization of the App post-revision indicates your acknowledgment and acceptance of the amended terms.</p>
<h2>Our Commitment to Data Security</h2>
<p>We use certain physical, managerial, and technical safeguards that are designed to protect the integrity and
    security of your information. We cannot, however, ensure or warrant the security of any information you
    share or store with us through the IVM Credit Platform and Services, and you do so at your own risk.</p>
<p>Protecting your Personal Information is also your responsibility. Be mindful of keeping your password and
    other authentication information safe from third-parties, and immediately notify us of any unauthorized use
    of your login credentials. </p>
<h2>Children</h2>
<p> IVM Credit Platform and Services are intended for use by general audiences and are not targeted directly at
    children under 16.</p>
<p>Children under the age of 16 are not permitted to use the IVM Credit Platform or Services, and we do not seek
    or knowingly collect any personal information about children under 16 years of age. If we become aware that
    we have unknowingly collected information about a child under 16 years of age, we will make commercially
    reasonable efforts to delete such information from our database. If you are the parent or guardian of a
    child under 16 years of age who has provided us with their personal information, you may contact us at
    help@ivmindiafinance.in to request that it be deleted.</p>
<h2>Your Acceptance of These Terms</h2>
<p>By using the IVM Credit app or website, you consent to the collection, use, and sharing of your information
    as described in this Privacy Policy.</p>
<h2>Contact Information</h2>
<p>Please contact us with any inquiries about this Privacy Policy by email at help@ivmindiafinance.in.</p>
<p>PLOT NO 5, SHIVAJI NAGAR CIVIL LINES JAIPUR Jaipur RJ 302006 IN</p>
</div>
</template>
<style lang="less" scoped>
.wrapper {
    padding: 30px;

    h1 {
        font-size: 40px;
        color: #333;
        margin-bottom: 40px;
        font-weight: 700;
    }

    h2 {
        font-size: 30px;
        color: #333;
        margin-bottom: 40px;
        font-weight: 700;
    }

    p {
        font-size: 24px;
        color: #333;
        margin-bottom: 30px;
        line-height: 1.5;
    }
}
</style>